import '@/utils/vfs_fonts' // この行がないとテストが通らない
import { createPdf } from 'pdfmake/build/pdfmake.min.js'
import {
  makeFooter,
  makePageSize,
  makeSignatureText
} from '@/utils/print_utils'
import { makeOwnerPatientText } from './print_utils'

export const makeDocDefinition = ({
  printOptions,
  clinic,
  clinicImage,
  owner,
  patient,
  examination,
  examinationDate
}) => {
  const paperSize = printOptions.paperSize
  const ratio = paperSize === 'A4' ? 1 : paperSize === 'B5' ? 0.84 : 0.7
  const patientText = makeOwnerPatientText({
    owner,
    patient,
    patientShowIdFlg: true,
    speciesName: examination.speciesName
  })
  const clinicText = makeSignatureText({
    clinic,
    clinicImage,
    ratio,
    showClinicAddress: printOptions.showClinicAddress,
    showClinicEmail: printOptions.showClinicEmail,
    showClinicName: printOptions.showClinicName,
    showClinicTel: printOptions.showClinicTel
  })
  const contentHeader = {
    columns: [
      {
        stack: [
          {
            //右端の医院情報のどれかの文字数が長い時に「検査結果」の文字が改行されないようwidthを設定。
            //widthはcolumnsと組み合わせて使用しないと反映されないようなので下記のような書き方をしている。
            columns: [
              { text: '検査結果', fontSize: 40 * ratio, width: 260 * ratio }
            ]
          },
          patientText
        ],
        width: '*'
      },
      { stack: clinicText, width: 'auto', margin: [10, 0, 0, 0] }
    ]
  }
  const examinationNameAndDateRow = {
    width: 530 * ratio,
    margin: [0, 15, 0, 10],
    columns: [
      { text: examination.treatmentName },
      { text: '', width: '*' },
      { text: examinationDate, alignment: 'right' }
    ]
  }
  const examinationTableRows = examination.resultTopicClasses.reduce(
    (examinationTableRows, topicClass) => {
      const classNameCell = {
        text: topicClass.topicClassName,
        rowSpan: topicClass.resultTopics.length,
        style: 'cell'
      }
      const rows = topicClass.resultTopics.map((topic, i) => {
        return [
          i === 0 ? classNameCell : '',
          { text: topic.topicName, style: 'cell' },
          { text: topic.result, style: 'cell' },
          { text: topic.unit, style: 'cell' },
          { text: topic.reference, style: 'cell' },
          { text: topic.comment, style: 'cell' }
        ]
      })
      return examinationTableRows.concat(rows)
    },
    []
  )
  const content = [
    contentHeader,
    examinationNameAndDateRow,
    {
      width: 'auto',
      layout: 'examinationTable',
      table: {
        headerRows: 1,
        widths: ['20%', '20%', '15%', '10%', '15%', '20%'],
        body: [
          [
            { text: '項目区分名', style: 'cell' },
            { text: '項目名', style: 'cell' },
            { text: '結果', style: 'cell' },
            { text: '単位', style: 'cell' },
            { text: '基準値', style: 'cell' },
            { text: 'コメント', style: 'cell' }
          ],
          ...examinationTableRows
        ]
      }
    }
  ]
  return {
    content,
    footer: (currentPage, pageCount) =>
      makeFooter({
        currentPage,
        fontSize: 11 * ratio,
        pageCount
      }),
    styles: {
      patientStyle: {
        alignment: 'left',
        fontSize: 16 * ratio,
        margin: [5, 5, 5, 5]
      },
      cell: { alignment: 'center', fontSize: 10 * ratio }
    },
    defaultStyle: {
      font: 'NotoSansMono',
      fontSize: 12 * ratio,
      color: '#3e3e3e',
      preserveLeadingSpaces: true
    },
    pageSize: makePageSize(printOptions.paperSize),
    pageMargins: [20, 20, 20, 30 + 11 * ratio],
    pageOrientation: 'portrait'
  }
}

// args = {
//   printOptions,
//   clinic,
//   clinicImage,
//   patient,
//   examination
//   examinationDate,
// }
export const printExamination = args => {
  const docDefinition = makeDocDefinition(args)
  const fonts = {
    NotoSansMono: {
      normal: 'NotoSansMonoCJKJPRegular.otf',
      bold: 'NotoSansMonoCJKJPRegular.otf',
      italics: 'NotoSansMonoCJKJPRegular.otf',
      bolditalics: 'NotoSansMonoCJKJPRegular.otf'
    }
  }
  const tableLayouts = {
    examinationTable: {
      hLineColor: '#3e3e3e',
      vLineColor: '#3e3e3e',
      fillColor: (rowIndex, node, colIndex) =>
        rowIndex === 0 ? '#f0f0f0' : null
    }
  }
  createPdf(docDefinition, tableLayouts, fonts).open()
}
